import { render, staticRenderFns } from "./goodsReceiving.vue?vue&type=template&id=128e10ca&"
import script from "./goodsReceiving.vue?vue&type=script&lang=js&"
export * from "./goodsReceiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports